import React from 'react';
import { Building, Hash, Calendar } from 'lucide-react';

const DiscrepancyCard = ({ discrepancy, project, onClick }) => {
  const formatJobNumber = () => {
    if (!project?.jobNumber) return "N/A";
    return project.rev ? `${project.jobNumber} Rev ${project.rev}` : project.jobNumber;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div
      onClick={onClick}
      style={{
        background: 'var(--dark-elevated)',
        border: '1px solid var(--gray-600)',
        borderRadius: 'var(--radius-lg)',
        padding: 'var(--space-4)',
        cursor: 'pointer',
        transition: 'all var(--transition-fast)',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = 'var(--gray-500)';
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = 'var(--shadow-md)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'var(--gray-600)';
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      {/* Card Header - Discrepancy Type */}
      <div
        style={{
          marginBottom: 'var(--space-3)',
          paddingBottom: 'var(--space-3)',
          borderBottom: '1px solid var(--gray-700)',
        }}
      >
        <h3
          style={{
            fontSize: 'var(--text-lg)',
            fontWeight: 'var(--font-semibold)',
            color: 'var(--gray-50)',
            margin: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          title={discrepancy.type || discrepancy.name || 'Discrepancy'}
        >
          {discrepancy.type || discrepancy.name || 'Discrepancy'}
        </h3>
      </div>

      {/* Card Body */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--space-2)',
        }}
      >
        {/* Project Name */}
        <div
          style={{
            fontSize: 'var(--text-base)',
            fontWeight: 'var(--font-medium)',
            color: 'var(--gray-100)',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          title={project?.projectName}
        >
          {project?.projectName || 'Unknown Project'}
        </div>

        {/* Job Number */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--space-2)',
          }}
        >
          <Hash
            size={14}
            style={{
              flexShrink: 0,
              color: 'var(--gray-400)',
            }}
          />
          <span
            style={{
              fontSize: 'var(--text-sm)',
              color: 'var(--gray-300)',
              fontWeight: 'var(--font-medium)',
            }}
          >
            {formatJobNumber()}
          </span>
        </div>

        {/* Client Name */}
        {project?.clientName && (
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 'var(--space-2)',
            }}
          >
            <Building
              size={14}
              style={{
                flexShrink: 0,
                marginTop: '2px',
                color: 'var(--gray-400)',
              }}
            />
            <span
              style={{
                fontSize: 'var(--text-sm)',
                color: 'var(--gray-300)',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              title={project.clientName}
            >
              {project.clientName}
            </span>
          </div>
        )}

        {/* Created Date */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--space-2)',
            marginTop: 'auto',
            paddingTop: 'var(--space-2)',
          }}
        >
          <Calendar
            size={14}
            style={{
              flexShrink: 0,
              color: 'var(--gray-400)',
            }}
          />
          <span
            style={{
              fontSize: 'var(--text-xs)',
              color: 'var(--gray-400)',
            }}
          >
            Created {formatDate(discrepancy.created_at)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default DiscrepancyCard;
